// extracted by mini-css-extract-plugin
module.exports =  {"alginBrandIdButton":"alginBrandIdButton__PDJMe","flexContainer":"flexContainer__RAqLe","flexItem":"flexItem__IGNds","tip":"tip__uh736"};